import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "aggregation_med",
  "use": "aggregation_med-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"aggregation_med\"><path d=\"M.75 0H0v1.5h.75V0zM0 14h.75v-1.5H0V14zM3.53 0H2.14v1.5h1.39V0zM2.14 14h1.39v-1.5H2.14V14zM6.31 0H4.92v1.5h1.39V0zm5.55 0h-1.39v1.5h1.39V0zM9.08 0H7.69v1.5h1.39V0zM0 5.75h14v-1.5H0v1.5zM4.92 14h1.39v-1.5H4.92V14zm8.33-14v1.5H14V0h-.75zM0 9.75h14v-1.5H0v1.5zM7.69 14h1.39v-1.5H7.69V14zm5.56 0H14v-1.5h-.75V14zm-2.78 0h1.39v-1.5h-1.39V14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol